export default {
    services: '{n} usluga',
    reservations: '1 rezervacija | {n} rezervacije',
    offer_company: 'Kompanijske usluge',
    offer_user: 'Korisničke usluge',
    no_slots_in_past: 'Nema rezervacija za odabrani datum',
    filter: 'Filter',
    error_slot_within_two_hours: 'Ne možete uređivati slotove koji su u narednih dva sata',
    status_successfully_changed: 'Status rezervacije je uspiješno promenjen',
    unavailable_slot: 'Slot nije dostupan',
    shorten_reservation: 'Skraćena rezervacija',
    go_to_next_month: 'Sledeći mjesec',
}
